// MonthBeer.styles.ts

import { SxProps, Theme } from '@mui/material';

export const styles: Record<string, SxProps<Theme>> = {
  container: {
    p: 2,
  },
  title: {
    textAlign: 'center',
    fontWeight: 'bold',
    mb: 4,
  },
  imageWrapper: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#ffffff',
    minHeight: { xs: 280, sm: 360 },
    p: { xs: 2, sm: 3 },
    borderTopLeftRadius: { xs: 4, sm: 16 },
    borderBottomLeftRadius: { xs: 0, sm: 16 },
    borderTopRightRadius: { xs: 4, sm: 0 },
  },
  image: {
    width: 'auto',
    height: 'auto',
    maxWidth: '100%',
    maxHeight: { xs: 320, sm: 420 },
    objectFit: 'contain',
  },
};
